import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';

export class BreachPathDetailsBaseDataProvider extends BaseWebComponentDataProvider {
}
